// Hero de la page article individuel

import { Link } from "react-router-dom";
import { Clock, Calendar, ArrowLeft } from "lucide-react";
import { Article, categoryColors, formatArticleDate } from "@/data/articles";

interface ArticleHeroProps {
  article: Article;
}

const ArticleHero = ({ article }: ArticleHeroProps) => {
  return (
    <section className="relative py-12 pt-28 bg-[#0F172A]">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          {/* Retour au blog */}
          <Link
            to="/blog"
            className="inline-flex items-center gap-2 text-sm text-white/50 hover:text-white transition-colors mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            Retour au blog
          </Link>

          {/* Badge categorie */}
          <span className={`inline-flex px-3 py-1 rounded-full text-xs font-medium border ${categoryColors[article.category]}`}>
            {article.category}
          </span>

          {/* Titre */}
          <h1 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight">
            {article.title}
          </h1>

          {/* Meta */}
          <div className="mt-6 flex items-center gap-6 text-sm text-white/50">
            <span className="flex items-center gap-2">
              <Calendar className="w-4 h-4" />
              Publie le {formatArticleDate(article.publishedAt)}
            </span>
            <span className="flex items-center gap-2">
              <Clock className="w-4 h-4" />
              {article.readingTime} min de lecture
            </span>
          </div>

          {/* Image principale (optionnelle) */}
          {article.image && (
            <div className="mt-8 rounded-2xl overflow-hidden">
              <img
                src={article.image}
                alt={article.title}
                loading="lazy"
                className="w-full aspect-[21/9] object-cover"
              />
            </div>
          )}
        </div>
      </div>

      {/* Gradient de fond subtil */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-1/2 left-1/4 w-96 h-96 bg-[#F59E0B]/5 rounded-full blur-3xl -translate-y-1/2" />
      </div>
    </section>
  );
};

export default ArticleHero;
